/**
 * Hook for managing vocabulary service state
 * Provides initialization status for the vocabulary system
 */
export function useVocabularyService() {
  // Service is always ready since vocabulary is local data
  return {
    isReady: true,
    isInitializing: false,
  };
}

